import { Button } from '@/components/atoms/Button/Button.tsx'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/atoms/Dialog/Dialog.tsx'

export interface SessionExpiredDialogLabels {
  readonly title: string
  readonly body: string
  readonly signIn: string
  readonly close: string
}

export interface SessionExpiredDialogProps {
  readonly open: boolean
  readonly labels: SessionExpiredDialogLabels
  readonly onSignIn: () => void
  readonly onClose: () => void
}

export const SESSION_EXPIRED_DIALOG_ATTRIBUTE = 'data-session-expired-dialog'

export const SessionExpiredDialog = ({ open, labels, onSignIn, onClose }: SessionExpiredDialogProps) => (
  <Dialog
    open={open}
    onOpenChange={(value) => {
      if (!value) {
        onClose()
      }
    }}>
    <DialogContent
      {...{ [SESSION_EXPIRED_DIALOG_ATTRIBUTE]: '' }}
      tabIndex={-1}
      // The dialog often opens under someone still typing: focusing a button would let the next space
      // or Enter press it, so the dialog itself takes the focus and Tab reaches the buttons.
      onOpenAutoFocus={(event) => {
        event.preventDefault()
        if (event.currentTarget instanceof HTMLElement) {
          event.currentTarget.focus()
        }
      }}
      onInteractOutside={(event) => {
        event.preventDefault()
      }}>
      <DialogHeader>
        <DialogTitle>{labels.title}</DialogTitle>
        <DialogDescription>{labels.body}</DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button className="py-1.5" onClick={onClose}>
          {labels.close}
        </Button>
        <Button variant="primary" className="py-1.5" onClick={onSignIn}>
          {labels.signIn}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
)
